import { FC, ReactNode } from 'react';
import { BackArrow, CloseBlackIcon } from '../../assets/icons';

interface SlideOutPanelProp {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  enableBgClose?: boolean;
  closeButtonTemplate?: () => ReactNode;
  headClassName?: string;
  title?: string;
  onBack?: () => void;
  showBackButton?: boolean;
  /** Custom width class (e.g., "w-full md:w-1/2") */
  widthClassName?: string;
  /** Position of the panel: "left" or "right" (default: "right") */
  position?: 'left' | 'right';
}
const SlideOutPanel: FC<SlideOutPanelProp> = ({
  children,
  isOpen,
  onClose,
  closeButtonTemplate,
  onBack,
  title = '',
  headClassName = '',
  showBackButton = false,
  enableBgClose = true,
  widthClassName,
  position = 'right',
}) => {
  const isLeft = position === 'left';
  const positionClass = isLeft ? 'left-0' : 'right-0';
  const translateClass = isOpen ? '' : isLeft ? '-translate-x-full' : 'translate-x-full';

  return (
    <div className={`z-30 w-full h-full fixed inset-0  ${!isOpen ? 'invisible' : ''}`}>
      <div
        onClick={() => (enableBgClose ? onClose() : null)}
        className={`absolute inset-0 w-full h-full duration-500 ease-out transition-all  cursor-pointer bg-gray-900 dark:bg-black opacity-${
          isOpen ? '50' : '0'
        } overflow-hidden`}
      />
      <div
        className={` absolute top-0 ${positionClass}  flex flex-col duration-300 ease-out transition-all h-[calc(100dvh)] ${
          widthClassName || ''
        } ${translateClass} `}
      >
        <div
          className={`relative ${
            widthClassName ? 'w-full' : 'w-fit max-w-[100vw]'
          } flex-1 flex flex-col overflow-hidden  ${headClassName || ''}`}
        >
          <div className="flex w-full items-center p-5">
            {showBackButton ? (
              <BackArrow
                className="cursor-pointer text-14 z-10 top-4"
                onClick={() => {
                  if (onBack) onBack();
                }}
              />
            ) : (
              <div className="w-4" />
            )}
            <span className="text-base flex-1 text-center">{title}</span>
            {closeButtonTemplate ? (
              closeButtonTemplate()
            ) : (
              <CloseBlackIcon className="right-5 cursor-pointer text-14 z-10 top-4" onClick={onClose} />
            )}
          </div>
          <div
            className={`relative ${
              widthClassName ? 'w-full' : 'w-fit max-w-[100vw]'
            } text-left flex-1 flex flex-col h-100 overflow-y-auto`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideOutPanel;
